import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt, faClock } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import LazyLoad from 'react-lazyload';
import { colorOptions } from '../../../helpers/select'
import LocaleLink from '../../Routes/LocaleLink'

export default function BlogPageCard(props) {
    const { data } = props;
    const link = (props.from_press && !!props.link) ? { pathname: props.link } : `/blog/${data.category.slug}/${data.slug}`;

    let color = props.from_press ? colorOptions[Math.floor(Math.random() * colorOptions.length)].value : data.category_color;
    let target = props.from_press && !!props.link ? '_blank' : '';

    let className = `card-container ${(props?.className) ?? ''}`

    return (
        <LocaleLink className={className} to={link} target={target} style={props.style}>
            <div className={"card card-" + color}>
                <LazyLoad>
                    <img
                        src={data.attachment ? data.attachment.thumbnail_url : ''}
                        alt={data.seo_image_alt ?? ''} />
                </LazyLoad>
                <div className="card-body">
                    <h3 style={{ color: color }}>{data.title}</h3>
                    <ul className="post-time">
                        {data.published_at &&
                        <li className='blog-icon' style={{ color: color }}>
                            <span>
                                <FontAwesomeIcon icon={faCalendarAlt} />&nbsp;
                                {moment(data.published_at).format('DD.MM.YYYY')}
                            </span>
                        </li>}
                        {data.reading_time &&
                        <li className='blog-icon' style={{ color: color }}>
                            <span>
                                <FontAwesomeIcon
                                    icon={faClock} />&nbsp;{data.reading_time} min
                            </span>
                        </li>}
                    </ul>
                </div>
            </div>
        </LocaleLink>
    )
}
